import { render, staticRenderFns } from "./payment-method-slide-group.vue?vue&type=template&id=275ffc38"
import script from "./payment-method-slide-group.ts?vue&type=script&lang=ts&external"
export * from "./payment-method-slide-group.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-method-slide-group.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports